function initProductOnboarding() {
  var root = document.getElementById('product-onboarding');
    if (!root) return;
  var sliderEl = root.querySelector('[data-onboarding-slider]');
  var frequency = root.dataset.frequency || 'session';
  var cookieName = 'po_seen_' + root.dataset.sectionId;
  var cookieDays = parseInt(root.dataset.cookieDays, 10) || 30;
  var swiperInstance = null;

  function setCookie(name, value, days) {
    var expires = '';
    if (days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? match[1] : null;
  }

  function alreadySeen() {
    if (frequency === 'always') return false;
    return getCookie(cookieName) === '1';
  }

  function markSeen() {
    if (frequency === 'always') return;
    // "once" persiste por muito tempo; "session" expira ao fechar o navegador (cookie de sessão)
    var days = frequency === 'session' ? 0 : cookieDays;
    setCookie(cookieName, '1', days);
  }

  function initSwiper() {
    if (swiperInstance || typeof window.Swiper === 'undefined') return;
    swiperInstance = new window.Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: false,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    root.querySelectorAll('[data-onboarding-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (swiperInstance) swiperInstance.slideNext();
      });
    });

    root.querySelectorAll('[data-onboarding-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (swiperInstance) swiperInstance.slidePrev();
      });
    });
  }

  function openProductOnboarding() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-onboarding-open');
    initSwiper();
  }

  function closeProductOnboarding() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-onboarding-open');
    markSeen();
  }

  // Fechar
  root.querySelectorAll('[data-onboarding-close]').forEach(function (el) {
    el.addEventListener('click', closeProductOnboarding);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeProductOnboarding();
  });

  // Gatilhos externos: qualquer elemento com data-open-onboarding
  document.querySelectorAll('[data-open-onboarding]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openProductOnboarding();
    });
  });

  // Abertura automática
  if (!alreadySeen()) {
    var delay = parseInt(root.dataset.openDelay, 10) || 0;
    window.setTimeout(openProductOnboarding, delay);
  }

  // Expor controle global para uso externo (ex.: botão no header)
  window.openProductOnboarding = openProductOnboarding;
  window.closeProductOnboarding = closeProductOnboarding;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductOnboarding);
} else {
  initProductOnboarding();
}